var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.9,89.44H158l-18.5-26.38-38-11.34L72.87,69.34a8.2,8.2,0,0,0,3.5,15.57,8,8,0,0,0,5.43-2.12l20.75-14.06L119,73.67l-44.53,59.4L47,135.75h-.13a8.19,8.19,0,0,0-.1,16.38h.1a8.6,8.6,0,0,0,1.7-.18l35.29-3.6,20.66-25.68,24.78,19.38-13.65,36.23h0a8.27,8.27,0,0,0-.37,2.46,8.09,8.09,0,0,0,16.09,1.32l17.24-47.74L125.2,116.21,141,92.42l10.39,12.66,23.52.75a8.2,8.2,0,0,0,0-16.39M169.76,44a14.13,14.13,0,1,1-14.13-14.28A14.2,14.2,0,0,1,169.76,44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.9,89.44H158l-18.5-26.38-38-11.34L72.87,69.34a8.2,8.2,0,0,0,3.5,15.57,8,8,0,0,0,5.43-2.12l20.75-14.06L119,73.67l-44.53,59.4L47,135.75h-.13a8.19,8.19,0,0,0-.1,16.38h.1a8.6,8.6,0,0,0,1.7-.18l35.29-3.6,20.66-25.68,24.78,19.38-13.65,36.23h0a8.27,8.27,0,0,0-.37,2.46,8.09,8.09,0,0,0,16.09,1.32l17.24-47.74L125.2,116.21,141,92.42l10.39,12.66,23.52.75a8.2,8.2,0,0,0,0-16.39ZM169.76,44a14.13,14.13,0,1,1-14.13-14.28A14.2,14.2,0,0,1,169.76,44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/RUNNING.9e7e9da3f2fb84057951884f30444ae6.svg";
export { ForwardRef as ReactComponent };